/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiTalent } from './Talent';
import { ApiFranchise } from './Franchise';
import { ApiArticleBlock } from './ArticleBlock';
import { ApiShow } from './Show';

export interface ArticleRequest {

    id?: string;

    /**
     * Lead image
     */
    lead_image?: string;

    /**
     * Title
     */
    title?: string;

    /**
     * Feed headline
     */
    feed_headline?: string;

    /**
     * Feed summary
     */
    feed_summary?: string;

    /**
     * Publish date
     */
    publish_date?: string;

    talent?: ApiTalent[];

    /**
     * Tags
     */
    tags?: string;

    /**
     * Franchise involved
     */
    franchise?: ApiFranchise;

    members_only?: boolean;

    /**
     * Pin expiration date for article
     */
    pin_on_original_reporting?: string;

    /**
     * Lead image credit
     */
    lead_image_credit?: string;

    /**
     * Image caption
     */
    lead_image_caption?: string;

    /**
     * Title
     */
    superhead?: string;

    /**
     * Title
     */
    subhead?: string;

    blocks?: ApiArticleBlock[];

    /**
     * Show involved
     */
    show?: ApiShow;

}

@Model('Article')
export class ApiArticle extends BaseModel implements ArticleRequest {

    
    
    id: string;

    /**
     * Lead image
     */
    
    
    lead_image: string;

    /**
     * Title
     */
    
    
    title: string;

    /**
     * Feed headline
     */
    
    
    feed_headline: string;

    /**
     * Feed summary
     */
    
    
    feed_summary: string;

    /**
     * Publish date
     */
    
    
    publish_date: string;

    @Type('ApiTalent')
    @Expand()
    talent: ApiTalent[];

    /**
     * Tags
     */
    
    
    tags: string;

    /**
     * Franchise involved
     */
    @Type('ApiFranchise')
    @Expand()
    franchise: ApiFranchise;

    
    
    members_only: boolean;

    /**
     * Pin expiration date for article
     */
    
    
    pin_on_original_reporting: string;

    /**
     * Lead image credit
     */
    
    
    lead_image_credit: string;

    /**
     * Image caption
     */
    
    
    lead_image_caption: string;

    /**
     * Title
     */
    
    
    superhead: string;

    /**
     * Title
     */
    
    
    subhead: string;

    @Type('ApiArticleBlock')
    @Expand()
    blocks: ApiArticleBlock[];

    /**
     * Show involved
     */
    @Type('ApiShow')
    @Expand()
    show: ApiShow;

}
